import React, { useEffect, useState, Children } from 'react';
import { Button, Modal } from 'react-bootstrap';
import CloseButton from 'react-bootstrap/CloseButton';
import Select from 'react-select';
import { toast } from 'react-toastify';
import textUtils from '../common/utilities/TextUtils';
import { ADD_UPDATE, DYNAMIC_TABLE, DYNAMIC_TABLE_ATTRIBUTE, DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET, LIST, getApiPath } from "../../api/ApiConst"
import apiCaller from "../../api/ApiCaller";
import { useCallback } from 'react';
import { get, set } from 'lodash';

// Move to settings/constants
const ENUM_TYPE = 'ENUM'

const TableAttributeAddEdit = (props) => {
    const attributeTypeOptions = [
        { label: "Integer", value: "INT" },
        { label: "Double", value: "DOUBLE" },
        { label: "Long", value: "LONG" },
        { label: "Boolean", value: "BOOLEAN" },
        { label: "String", value: "STRING" },
        { label: "Array of Object", value: "ARRAYOFOBJ" },
        { label: "Size of Array", value: "SIZEOFARRAY" },
        { label: "UUId", value: "UUID" },
        { label: "Json List", value: "JSON_LIST" },
        { label: "Collection Object", value: "COLLECTION_OBJECT" },
        { label: "Collection Object List", value: "COLLECTION_OBJECT_LIST" },
        { label: "ENUM", value: "ENUM" },
        { label: "Date", value: "DATE" },
        { label: "DateTime", value: "DATETIME" },
        { label: "Time", value: "TIME" },
        { label: "File Url", value: "FILE_URL" },
    ]
    const [attributeTypeKeyValue, setAttributeTypeKeyValue] = useState("");
    const [referenceTableKeyValue, setReferenceTableKeyValue] = useState("");
    const [foreignKeyKeyValue, setForeignKeyKeyValue] = useState("")
    const [keyAttributeKeyValue, setKeyAttributeKeyValue] = useState("")
    const [valueAttributeKeyValue, setValueAttributeKeyValue] = useState("")
    const [mappingTableAttributeKeyValueOptions, setMappingTableAttributeKeyValueOptions] = useState([])
    const [attributeObj, setAttributeObj] = useState({
        id: "",
        tableId: "",
        name: "",
        label: "",
        type: "",
        attributeLength: 255,
        defaultValue: {},
        nullValue: true,
        autoIncrement: false,
        tableViewAttribute: true,
        referenceTable: null,
        comment: "",
        formAttribute: true,
        defaultAttribute: false,
        unique: false,
        keyAttribute: null,
        valueAttribute: null,
        enumValues: null,
        referenceDataColumn: false,
        referenceWithMappingTable: false,
        mappingTableId: null, 
        mappingTableName: "",
        currentTableParameterReferenceId: null,
        currentTableParameterReferenceName: "",
        referenceTableParameterReferenceId: null,
        referenceTableParameterReferenceName: "",
    })

    const [referenceTableOptions, setReferenceTableOptions] = useState([])
    const [keyValueAttributeOptions, setKeyValueAttributeOptions] = useState([])

    useEffect(() => {
        let url = getApiPath(DYNAMIC_TABLE, LIST);
        let requestObj = {
            page: 0,
            size: 1000,
            searchFilters: [],
            sortRules: []
        };
        let options = [];
        apiCaller.callPostApi(url, requestObj, {}, (response) => {
            response.data.map((tableData, i) => {
                options.push({ label: tableData.name, value: tableData._id })
            })
            setReferenceTableOptions(options);
            if (props.object.referenceTable !== null) {
                let obj = options.find(o => o.value === props.object.referenceTable);
                getKeyValueAttributeOptionsList(props.object.referenceTable)
                setReferenceTableKeyValue(obj);
            } else {
                setReferenceTableKeyValue("");
            }
        }, (error) => {
            // toast.error(error.response.data.message);
            // toast.error(error);
        }
        )

    }, [])

    useEffect(() => {
        if (props.object != null) {
            setAttributeObj(props.object);            
            if (props.object.type !== "") {
                let selectedAttributeType = attributeTypeOptions?.find(option => option?.value === props?.object?.type);

                setAttributeTypeKeyValue({
                    label: selectedAttributeType?.label || props.object.type,
                    value: selectedAttributeType?.value || props.object.type
                });
            } else {
                setAttributeTypeKeyValue("");
            }

            if (get(props, 'object.type') === ENUM_TYPE && get(props, 'object.enumValues')) {
                setAttributeObj(prev => ({ ...prev, enumValues: get(props, 'object.enumValues').split(',') }))
            }
        }
    }, [props.object]);

    // Close Attribute Create/Update Model Box
    const toggle = () => {
        props.close();
    }

    const getMappingTableKeyValueOptionsList = useCallback(
        (tableId) => {
            let keyValueAttributeListUrl = DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET.replaceAll("{dynamic-table-id}", tableId);
            var options = [];
            apiCaller.callPostApi(keyValueAttributeListUrl, tableId, {}, (response) => {
                response.data.map((data, i) => {
                    options.push({ label: data.name, value: data.id })
                })
                setMappingTableAttributeKeyValueOptions(options)
            }, (error) => {
                // toast.error(error.response.data.message);
            }
        )
    }, [])
    // get Key-Value attribute Options List 
    const getKeyValueAttributeOptionsList = useCallback(
        (tableId) => {
            let keyValueAttributeListUrl = DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET.replaceAll("{dynamic-table-id}", tableId);
            var options = [];
            apiCaller.callPostApi(keyValueAttributeListUrl, tableId, {}, (response) => {
                response.data.map((data, i) => {
                    options.push({ label: data.name, value: data.id })
                })
                setKeyValueAttributeOptions(options)
                if (props.object.keyAttribute != null) {
                    let keyAttributeObj = options.find(o => o.value === props.object.keyAttribute);
                    setKeyAttributeKeyValue(keyAttributeObj)
                } else {
                    setKeyAttributeKeyValue("")
                }
                if (props.object.valueAttribute != null) {
                    let valueAttributeObj = options.find(o => o.value === props.object.valueAttribute);
                    setValueAttributeKeyValue(valueAttributeObj)
                } else {
                    setValueAttributeKeyValue("")
                }

                if (props.object.foreignKey != null) {
                    let foreignKeyObj = options.find(o => o.value === props.object.foreignKey);
                    setForeignKeyKeyValue(foreignKeyObj)
                } else {
                    setForeignKeyKeyValue("")
                }
            }, (error) => {
                // toast.error(error.response.data.message);
                setKeyValueAttributeOptions(options);
            })
        },
        [props.object.referenceTable],
    );

    //Text Change Event
    const handleTextChange = (e, type, id = "") => {
        if (type === "checkbox") {
            if (e.target.id === "nullValue") {
                setAttributeObj(prev => ({
                    ...prev,
                    [e.target.id]: e.target.checked,
                    defaultValue: {}
                }));
            }
            setAttributeObj(prev => ({ ...prev, [e.target.id]: e.target.checked }));
        } else if (type === ENUM_TYPE) {
            setAttributeObj(prev => ({
                ...prev,
                enumValues: attributeObj.enumValues.map((state, stateIndex) =>
                    stateIndex === id ? e.target.value : state
                )
            })
            )
        } else if (type === "text") {
            setAttributeObj(prev => ({ ...prev, [e.target.id]: e.target.value }));
        } else if (type === "select") {
            if (id === "type") {
                setAttributeTypeKeyValue(e);
                setAttributeObj(prev => ({ ...prev, [id]: e.value }))
            }
            
            else if (id === "referenceTable") {
                setReferenceTableKeyValue(e)
                setAttributeObj(prev => ({ ...prev, [id]: e.value, }))
                getKeyValueAttributeOptionsList(e.value)
            }
            
            else if (id === "mappingTable") {
                setAttributeObj(prev => ({ ...prev, mappingTableId: e?.value,mappingTableName:e?.label }))
                getMappingTableKeyValueOptionsList(e.value)
            }
            
            else if (id === "mappingSourceAttribute") {
                setAttributeObj(prev => ({ ...prev, currentTableParameterReferenceId: e?.value,currentTableParameterReferenceName:e?.label }))
            }
            
            else if (id === "mappingTargetAttribute") {
                setAttributeObj(prev => ({ ...prev, referenceTableParameterReferenceId: e?.value,referenceTableParameterReferenceName:e?.label }))
            }
            
            else if (id === "keyAttribute") {
                setKeyAttributeKeyValue(e)
                setAttributeObj(prev => ({ ...prev, [id]: e.value }))
            }
            
            else if (id === "valueAttribute") { 
                setValueAttributeKeyValue(e)
                setAttributeObj(prev => ({ ...prev, [id]: e.value }))
            }
            
            else if (id === "foreignKey") {
                setForeignKeyKeyValue(e)
                setAttributeObj(prev => ({ ...prev, [id]: e.value }))
            }
        }
    }

    const handleKeyPressOnlyAlphanumericUnderscore = (e) => {
        const key = e.key;
        if (
            key === 'Backspace' ||
            key === 'Delete' ||
            key === 'ArrowLeft' ||
            key === 'ArrowRight' ||
            key === 'Tab' ||
            key === 'Home' ||
            key === 'End'
        ) {
            return;
        }
        const isValid = /^[a-zA-Z0-9_]$/.test(key);
        if (!isValid) {
            e.preventDefault();
        }
    };
    

    // Create Attribute  
    const handleCreateAttribute = () => {
        let requestObj = attributeObj;
        if ((textUtils.isEmpty(requestObj.name, "Name", true)) ||
            textUtils.isEmpty(requestObj.type, "Type", true) ||
            (textUtils.isEmpty(requestObj.attributeLength, "Length", true) ||
            ((requestObj.type === "COLLECTION_OBJECT" || requestObj.type === "COLLECTION_OBJECT_LIST") && textUtils.isEmpty(requestObj.referenceTable, "Reference Table", true)) ||
            ((requestObj.type === "COLLECTION_OBJECT" || requestObj.type === "COLLECTION_OBJECT_LIST") && textUtils.isEmpty(valueAttributeKeyValue, "Key Attribute", true)) ||
            ((requestObj.type === "COLLECTION_OBJECT" || requestObj.type === "COLLECTION_OBJECT_LIST") && textUtils.isEmpty(valueAttributeKeyValue, "Value Attribute", true)) ||
            ((requestObj.type === "COLLECTION_OBJECT" || requestObj.type === "COLLECTION_OBJECT_LIST") && textUtils.isEmpty(foreignKeyKeyValue, "Foreign Key", true)) ||
            (requestObj.referenceWithMappingTable && textUtils.isEmpty(requestObj.mappingTableId, "Mapping Table", true)) ||
            (requestObj?.mappingTableId?.length > 0 && textUtils.isEmpty(requestObj.currentTableParameterReferenceId, "Mapping Source Attribute", true)) ||
            (requestObj?.mappingTableId?.length > 0 && textUtils.isEmpty(requestObj.referenceTableParameterReferenceId, "Mapping Target Attribute", true))
        )) {
            return false;
        }
        if (requestObj.type === ENUM_TYPE) {
            const value = Array.isArray(requestObj.enumValues) ? requestObj.enumValues.filter(Boolean).join(',') : null
            set(requestObj, 'enumValues', value)
        } else {
            set(requestObj, 'enumValues', null)
        }

        let url = getApiPath(DYNAMIC_TABLE_ATTRIBUTE, ADD_UPDATE);
        apiCaller.callPostApi(url, requestObj, {}, (response) => {
            toast.success(`Attribute ${attributeObj.id ? "Updated" : "Created"} Successfully`);
            props.successCallBack();
            toggle();
        }, (error) => {
            toast.error(error.response.data.message);
        })
    }



    return (
        <>
            <Modal show={props.show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Table Attribute</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Name *</label>
                            <input type="text" className="form-control input-default"
                                id="name"
                                placeholder='Name'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                onKeyDown={handleKeyPressOnlyAlphanumericUnderscore}
                                value={attributeObj.name}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Label *</label>
                            <input type="text" className="form-control input-default"
                                id="label"
                                placeholder='Label'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                value={attributeObj.label}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Type *</label>
                            <Select
                                options={attributeTypeOptions}
                                value={attributeTypeKeyValue}
                                id="type"
                                onChange={(e) => handleTextChange(e, "select", "type")}
                                className="react-select-container"
                            />
                        </div>
                    </div>
                    {(attributeTypeKeyValue?.value === "COLLECTION_OBJECT" || attributeTypeKeyValue?.value === "COLLECTION_OBJECT_LIST") &&
                        <>
                            <div className="form-group row mb-3">
                                <div className="col-lg-12">
                                    <label>Reference Table *</label>
                                    <Select
                                        options={referenceTableOptions}
                                        value={referenceTableKeyValue}
                                        id="referenceTable"
                                        onChange={(e) => handleTextChange(e, "select", "referenceTable")}
                                        className="react-select-container"
                                    />
                                </div>
                            </div>
                            <div className="form-group row mb-3">
                                <div className="col-lg-6">
                                    <label>Key Attribute *</label>
                                    <Select
                                        options={keyValueAttributeOptions}
                                        value={keyAttributeKeyValue}
                                        id="keyAttribute"
                                        onChange={(e) => handleTextChange(e, "select", "keyAttribute")}
                                        className="react-select-container"
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <label>Value Attribute *</label>
                                    <Select
                                        options={keyValueAttributeOptions}
                                        value={valueAttributeKeyValue}
                                        id="valueAttribute"
                                        onChange={(e) => handleTextChange(e, "select", "valueAttribute")}
                                        className="react-select-container"
                                    />
                                </div>
                            </div>

                            <div className="form-group row mb-3">
                                <div className="col-lg-12">
                                    <label>Foreign Key *</label>
                                    <Select
                                        options={keyValueAttributeOptions}
                                        value={foreignKeyKeyValue}
                                        id="foreignKey"
                                        onChange={(e) => handleTextChange(e, "select", "foreignKey")}
                                        className="react-select-container"
                                    />
                                </div>
                            </div>
                        </>
                    }

                    {attributeTypeKeyValue?.value === ENUM_TYPE && (
                        <>
                            {Children.toArray(
                                Array.isArray(attributeObj?.enumValues) && attributeObj.enumValues.map((value, index) => (
                                    <>
                                        <div className="d-flex align-items-end form-group row mb-3">
                                            <div className="col-lg-10">
                                                <label>Option {index + 1}</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default"
                                                    placeholder={`Option ${index + 1}`}
                                                    onChange={(e) => handleTextChange(e, "ENUM", index)}
                                                    value={value}
                                                />
                                            </div>
                                            <div className="col-lg-2">
                                                <CloseButton
                                                    onClick={(e) =>
                                                        setAttributeObj(prev => ({
                                                            ...prev,
                                                            enumValues: attributeObj.enumValues.filter((state, stateIndex) => stateIndex !== index
                                                            )
                                                        })
                                                        )}
                                                />
                                            </div>
                                        </div>
                                    </>
                                ))
                            )}
                            <div className="my-3">
                                <Button
                                    variant="primary"
                                    onClick={() => setAttributeObj((prev) => ({ ...prev, enumValues: attributeObj?.enumValues ? [...attributeObj.enumValues, ""] : [""] }))}
                                >
                                    Add options
                                </Button>
                            </div>
                        </>
                    )}

                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Length *</label>
                            <input type="text" className="form-control input-default"
                                id="attributeLength"
                                placeholder='Length'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                value={attributeObj.attributeLength}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Default Value *</label>
                            <input type="text" className="form-control input-default"
                                id="defaultValue"
                                placeholder='Default Value'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                value={((typeof attributeObj.defaultValue) === "object") ? ((Object.keys(attributeObj.defaultValue).length) === 0) ? "" : attributeObj.defaultValue?.value : attributeObj.defaultValue}
                                disabled={attributeObj.nullValue}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Comment *</label>
                            <input type="text" className="form-control input-default"
                                id="comment"
                                placeholder='Comment'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                value={attributeObj.comment}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-4">
                                    <input
                                        type="checkbox"
                                        name="formAttribute"
                                        id="formAttribute"
                                        checked={attributeObj.formAttribute}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Form Attribute</label>
                                </div>
                                <div className="col-lg-4">
                                    <input
                                        type="checkbox"
                                        name="defaultAttribute"
                                        id="defaultAttribute"
                                        checked={attributeObj.defaultAttribute}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Default Attribute</label>
                                </div>
                                <div className="col-lg-4">
                                    <input
                                        type="checkbox"
                                        name="unique"
                                        id="unique"
                                        checked={attributeObj.unique}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Unique</label>
                                </div>
                                <div className="col-lg-4">
                                    <input
                                        type="checkbox"
                                        name="nullValue"
                                        id="nullValue"
                                        checked={attributeObj.nullValue}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Null Value</label>
                                </div>
                                <div className="col-lg-4">
                                    <input
                                        type="checkbox"
                                        name="tableViewAttribute"
                                        id="tableViewAttribute"
                                        checked={attributeObj.tableViewAttribute}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Table View Attribute</label>
                                </div>

                                <div className="col-lg-4">
                                    <input
                                        type="checkbox"
                                        name="referenceDataColumn"
                                        id="referenceDataColumn"
                                        checked={attributeObj.referenceDataColumn}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Reference Data Column</label>
                                </div>

                                {
                                    attributeObj?.referenceDataColumn &&
                                    <div className="col-lg-4">
                                        <input
                                            type="checkbox"
                                            name="referenceWithMappingTable"
                                            id="referenceWithMappingTable"
                                            checked={attributeObj.referenceWithMappingTable}
                                            onChange={(e) => handleTextChange(e, e.target.type)}
                                        />
                                        <label className='ms-2'>Reference With Mapping Table</label>
                                    </div>
                                }
                                {(attributeObj?.referenceWithMappingTable && attributeObj.referenceDataColumn)  &&
                                    <>
                                        <div className="form-group row mb-3">
                                            <div className="col-lg-12">
                                                <label>Mapping Table *</label>
                                                <Select
                                                    options={referenceTableOptions}
                                                    value={{value:attributeObj?.mappingTableId,label:attributeObj?.mappingTableName}}
                                                    id="mappingTable"
                                                    onChange={(e) => handleTextChange(e, "select", "mappingTable")}
                                                    className="react-select-container"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row mb-3">
                                            <div className="col-lg-6">
                                                <label>Mapping Source Attribute *</label>
                                                <Select
                                                    placeholder="Select Mapping Source Attribute"
                                                    options={mappingTableAttributeKeyValueOptions}
                                                    value={{value:attributeObj?.currentTableParameterReferenceId,label:attributeObj?.currentTableParameterReferenceName}}
                                                    id="mappingSourceAttribute"
                                                    onChange={(e) => handleTextChange(e, "select", "mappingSourceAttribute")}
                                                    className="react-select-container"
                                                />
                                            </div>
                                            <div className="col-lg-6">
                                                <label>Mapping Target Attribute *</label>
                                                <Select
                                                    placeholder="Select Mapping Target Attribute"
                                                    options={mappingTableAttributeKeyValueOptions}
                                                    value={{value:attributeObj?.referenceTableParameterReferenceId,label:attributeObj?.referenceTableParameterReferenceName}}
                                                    id="mappingTargetAttribute"
                                                    onChange={(e) => handleTextChange(e, "select", "mappingTargetAttribute")}
                                                    className="react-select-container"
                                                />
                                            </div>
                                        </div>
                                    </>
                                }

                                {(attributeObj.type === "INT" || attributeObj.type === "LONG") &&
                                    <div className="col-lg-4">
                                        <input
                                            type="checkbox"
                                            name="autoIncrement"
                                            id="autoIncrement"
                                            checked={attributeObj.autoIncrement}
                                            onChange={(e) => handleTextChange(e, e.target.type)}
                                        />
                                        <label className='ms-2'>Auto Increment</label>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary"
                        onClick={handleCreateAttribute}
                    >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default TableAttributeAddEdit
